module.exports = __webpack_public_path__ + "static/media/cvapp.134440eb.png";